import '../../../node_modules/img-comparison-slider/dist/styles.css';
import '../../css/external/imgComparisonSlider.scss';

require('../../../node_modules/img-comparison-slider/dist/index.js');